import { render } from "./Tariffs.vue?vue&type=template&id=9381f266&scoped=true&ts=true"
import script from "./Tariffs.vue?vue&type=script&lang=ts"
export * from "./Tariffs.vue?vue&type=script&lang=ts"

import "./Tariffs.vue?vue&type=style&index=0&id=9381f266&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9381f266"]])

export default __exports__